import { ShellActionButton } from "../shared/ShellActionButton";
import { IconChevronLeft, IconTrophy } from "../shared/Icons";

export function LearnFlowHeader({
  subtitle,
  rankHint,
  onBack,
  onLeaderboard,
}: {
  subtitle: string;
  rankHint?: number | null;
  onBack: () => void;
  onLeaderboard?: () => void;
}) {
  return (
    <header className="learn-flow-header">
      <button type="button" className="learn-back" aria-label="Back" onClick={onBack}>
        <IconChevronLeft />
      </button>
      <div className="learn-flow-title">
        <div className="muted caps">Play</div>
        <strong>{subtitle}</strong>
      </div>
      {onLeaderboard ? (
        <ShellActionButton
          label="Leaderboard"
          badge={rankHint ? `#${rankHint}` : null}
          onClick={onLeaderboard}
        >
          <IconTrophy />
        </ShellActionButton>
      ) : (
        <span style={{ width: 44 }} />
      )}
    </header>
  );
}
